'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TermsOfServiceBannerContainer = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _consent = require('../../redux/modules/consent');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _TermsOfServiceBanner = require('./TermsOfServiceBanner');

var _TermsOfServiceBanner2 = _interopRequireDefault(_TermsOfServiceBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var _getUiConsent = (0, _consent.getUiConsent)(state),
        submitted = _getUiConsent.submitted;

    return {
        submitted: submitted
    };
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        submitConsent: _consent.submitConsent
    }, dispatch);
};

var TermsOfServiceBannerContainer = exports.TermsOfServiceBannerContainer = function (_PureComponent) {
    (0, _inherits3.default)(TermsOfServiceBannerContainer, _PureComponent);

    function TermsOfServiceBannerContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TermsOfServiceBannerContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TermsOfServiceBannerContainer.__proto__ || (0, _getPrototypeOf2.default)(TermsOfServiceBannerContainer)).call.apply(_ref, [this].concat(args))), _this), _this.submitConsent = function () {
            _this.props.submitConsent(true, 'TermsOfServiceBanner');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(TermsOfServiceBannerContainer, [{
        key: 'render',
        value: function render() {
            var submitted = this.props.submitted;

            return (0, _jsx3.default)(_TermsOfServiceBanner2.default, {
                submitted: submitted,
                submitConsent: this.submitConsent
            });
        }
    }]);
    return TermsOfServiceBannerContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TermsOfServiceBannerContainer);


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfServiceBanner/TermsOfServiceBannerContainer.js
// module id = 48j4
// module chunks = 60